/**
 * Main layout component with sidebar and top bar
 */

import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import '../../styles/Layout.css';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const isFullHeightPage = location.pathname === '/explore';

  return (
    <div className="layout-container">
      <Sidebar 
        isMobileOpen={sidebarOpen} 
        onMobileClose={() => setSidebarOpen(false)} 
      />
      
      <div className={`layout-main${isFullHeightPage ? ' layout-main--full' : ''}`}>
        <TopBar onMobileMenuToggle={() => setSidebarOpen(!sidebarOpen)} />
        
        <main className={`layout-content${isFullHeightPage ? ' layout-content--full' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
